import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Lightbulb as TipIcon, Info as NoteIcon, Warning as WarnIcon } from '@mui/icons-material';
import { MP } from './manualPalette';

export const TipBox = ({ children }) => (
  <Alert
    icon={<TipIcon />}
    sx={{
      my: 2,
      borderLeft: `4px solid ${MP.greenMid}`,
      bgcolor: alpha(MP.greenMid, 0.08),
      color: MP.green,
      '& .MuiAlert-icon': { color: MP.greenMid },
    }}
  >
    {children}
  </Alert>
);

export const NoteBox = ({ children }) => (
  <Alert
    icon={<NoteIcon />}
    sx={{
      my: 2,
      borderLeft: `4px solid ${MP.blue}`,
      bgcolor: alpha(MP.blue, 0.07),
      color: MP.deepBlue,
      '& .MuiAlert-icon': { color: MP.blue },
    }}
  >
    {children}
  </Alert>
);

export const WarnBox = ({ children }) => (
  <Alert
    icon={<WarnIcon />}
    sx={{
      my: 2,
      borderLeft: `4px solid ${MP.yellow}`,
      bgcolor: alpha(MP.yellow, 0.1),
      color: '#5c4000',
      '& .MuiAlert-icon': { color: MP.yellow },
    }}
  >
    {children}
  </Alert>
);

export const StepList = ({ steps }) => (
  <Box component="ol" sx={{ pl: 0, my: 1.5, listStyle: 'none' }}>
    {steps.map((step, i) => (
      <Box
        key={i}
        component="li"
        sx={{
          mb: 1.25,
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            minWidth: 26,
            height: 26,
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${MP.deepBlue}, ${MP.blue})`,
            color: MP.yellow,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            fontSize: '0.75rem',
            flexShrink: 0,
            mt: 0.1,
          }}
        >
          {i + 1}
        </Box>
        <Typography variant="body2" sx={{ lineHeight: 1.75, color: '#1a1a2e', pt: 0.3 }}>
          {step}
        </Typography>
      </Box>
    ))}
  </Box>
);

export const BulletList = ({ items }) => (
  <Box component="ul" sx={{ pl: 0, my: 1.5, listStyle: 'none' }}>
    {items.map((item, i) => (
      <Box key={i} component="li" sx={{ mb: 1, display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        <Box
          sx={{
            minWidth: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: MP.yellow,
            border: `2px solid ${MP.greenMid}`,
            flexShrink: 0,
            mt: 0.6,
          }}
        />
        <Typography variant="body2" sx={{ lineHeight: 1.75, color: '#1a1a2e' }}>
          {typeof item === 'object' ? `${item.issue}: ${item.solution}` : item}
        </Typography>
      </Box>
    ))}
  </Box>
);

export const SectionHeading = ({ number, title }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.25,
      mt: 3,
      mb: 1.5,
      pb: 0.75,
      borderBottom: `1px solid ${alpha(MP.deepBlue, 0.15)}`,
    }}
  >
    {number && (
      <Box
        sx={{
          bgcolor: MP.green,
          color: MP.white,
          borderRadius: 1,
          px: 0.75,
          py: 0.25,
          fontSize: '0.68rem',
          fontWeight: 800,
          lineHeight: 1.5,
          minWidth: 32,
          textAlign: 'center',
          flexShrink: 0,
        }}
      >
        {number}
      </Box>
    )}
    <Typography
      variant="h6"
      sx={{ fontWeight: 700, color: MP.deepBlue, fontSize: '1rem' }}
    >
      {title}
    </Typography>
  </Box>
);
